/**
 * Recursively generates an array of all the key paths in an object in dot notation.
 * @param {Object}      obj             - The object to generate key paths for.
 * @param {string}      [parentKey='']  - The parent key for the current level of the object.
 * @returns {string[]}                    An array of key paths.
 */
export default function getKeyPaths(obj, parentKey = '') {
  const keyPaths = [];
  for (const [key, value] of Object.entries(obj)) {
    const currentKey = parentKey ? `${parentKey}.${key}` : key;
    if (typeof value === 'object' && value !== null) {
      keyPaths.push(...getKeyPaths(value, currentKey));
    } else {
      keyPaths.push(currentKey);
    }
  }
  return keyPaths;
}
